<template>
  <v-container class="new-campaign-introduction">
    <v-row justify="center" align="center" class="mt-2 mb-2">
      <v-img :src="require('@/assets/icons/handwave.png')" max-width="1.5rem" max-height="1.5rem" />
      <p class="title-text ml-2 mb-0">{{$t('NewCampaignInitialData.introduction.title')}}</p>
    </v-row>
    <p class="body-text text-center mt-2">{{$t('NewCampaignInitialData.introduction.introductionText')}}</p>

    <p class="section-text text-left pt-4">{{$t('NewCampaignInitialData.introduction.contractedEquipments')}}</p>
    <ul class="mb-4">
      <li class="body-text text-left" v-for="product in monitoringProducts" :key="product.id">{{ getProductDetailText(product) }}</li>
    </ul>

    <v-row justify="start" align="center" class="pt-4 mb-2">
      <v-img :src="require('@/assets/icons/calendar.png')" max-width="1.5rem" max-height="1.5rem" />
      <p class="section-text ml-2 mb-0">{{$t('NewCampaignInitialData.introduction.thingsToConsiderTitle')}}</p>
    </v-row>
    <p class="body-text text-left">{{$t('NewCampaignInitialData.introduction.thingsToConsiderText')}}</p>

    <v-row justify="start" align="center" class="pt-4 mb-2">
      <v-img :src="require('@/assets/icons/puzzle.png')" max-width="1.5rem" max-height="1.5rem" />
      <p class="section-text ml-2 mb-0">{{$t('NewCampaignInitialData.introduction.nextStepsTitle')}}</p>

    </v-row>
    <p class="body-text text-left">{{$t('NewCampaignInitialData.introduction.nextStepsText')}}</p>
    <ul>
      <li class="body-text text-left" v-for="item in $t('NewCampaignInitialData.introduction.nextStepsTextItems')" :key="item">{{item}}</li>
    </ul>

    <v-row justify="center" class="mt-2">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="campaignName"
          :placeholder="$t('NewCampaignInitialData.introduction.campaignNameInput.placeholder')"
          :hint="$t('NewCampaignInitialData.introduction.campaignNameInput.hint')"
          outlined
          background-color="white"
          persistent-hint
          flat
          :rules="[rules.fieldRequired]"
          validate-on-blur
          required
        />
      </v-col>
    </v-row>
    <div class="action-row">
      <v-row justify="center" class="mt-2">
        <v-btn color="#0098E1" class="submit-button" :disabled="!campaignName" :loading="loading" @click="startCampaign()">{{$t('NewCampaignInitialData.introduction.startCampaign')}}</v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { EQUIPMENT_TYPE, FIRESTORE_CAMPAIGN_PRE_DATA_STEPS, PRODUCT_TYPES } from '../../constants/const'
import { completePreDataStep } from '../../lib/crudOperations/write'
import { trackEvent } from '../../lib/track-events'
import { EVENTS_TO_TRACK } from '../../constants/const'
export default {
  name: 'NewCampaignIntroduction',
  props: {
    nextStep: {
      type: Function,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    campaignId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      campaignName: '',
      rules: {
        fieldRequired: v => !!v || this.$t('Config.fieldIsRequired')
      },
      loading: false
    }
  },
  methods: {
    getProductDetailText (product) {
      let deviceType = ''
      switch (product.deviceType) {
        case EQUIPMENT_TYPE.PIVOT:
          if (product.quantity > 0) {
            deviceType = this.$t('NewCampaignInitialData.pivots')
          } else {
            deviceType = this.$t('NewCampaignInitialData.pivot')
          }
          break
        case EQUIPMENT_TYPE.AF:
          if (product.quantity > 0) {
            deviceType = this.$t('NewCampaignInitialData.linears')
          } else {
            deviceType = this.$t('NewCampaignInitialData.linear')
          }
          break
        case EQUIPMENT_TYPE.IR:
          if (product.quantity > 0) {
            deviceType = this.$t('NewCampaignInitialData.irrigationReels')
          } else {
            deviceType = this.$t('NewCampaignInitialData.irrigationReel')
          }
          break
      }

      return `${product.quantity} ${this.$t('NewCampaignInitialData.introduction.contractedEquipmentsDetail', {deviceType, serviceName: product.serviceName.toUpperCase(), durationMonths: product.durationMonths})}`
    },
    async startCampaign () {
      try {
        this.loading = true
        trackEvent(EVENTS_TO_TRACK.CLICK_START_CAMPAIGN_BUTTON, {
          campaignName: this.campaignName,
          campaignId: this.campaignId
        })
        await completePreDataStep(this.campaignId, FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.INTRODUCTION, {campaignName: this.campaignName})
        this.nextStep()
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    monitoringProducts () {
      return this.products.filter(product => product.type === PRODUCT_TYPES.MONITORING)
    }
  }
}
</script>


// WEBPACK FOOTER //
// NewCampaignIntroduction.vue?2d3af34e